import { processError } from '../utils/processError';
import api from './index';

const getProfile = async (userId: number) => {
  try {
    const { data } = await api.get(
      `/authenticationservice/api/Authentication/GetProfile?userId=${userId}`
    );
    return data;
  } catch (e) {
    processError(e);
  }
};

const updateProfile = async (payload: FormData) => {
  try {
    const { data } = await api.put(
      '/authenticationservice/api/Authentication/ProfileUpdate',
      payload
    );
    return data;
  } catch (e) {
    processError(e);
  }
};

const accountApi = {
  getProfile,
  updateProfile,
};

export default accountApi;
